import { Component, Input,ViewChild, ElementRef,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'call-history-modal',
    template: `
    <div class="modal-header">
        <h4 class="modal-title">Hi there!</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
                                <app-call-history [batch_detail_id]="batch_detail_id"></app-call-history>
    
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
      </div>
    `
  })
  
  export class CallHistory {
    @Input() batch_detail_id;

    @ViewChild('modal') modal: ElementRef;

    @Output() onCreated: EventEmitter<void> = new EventEmitter<void>();

    public open(){
        //alert('Working call history')
         //const modRef = this.modalService.open(this.modal);
        //modRef.componentInstance.name = thename;
        
    }
  
    constructor(public modalService:NgbModal,public activeModal:NgbActiveModal) {}
  }